var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCheckShareholder = function SvgCheckShareholder(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.72065 0.974365C6.54315 0.974365 4.77793 2.73958 4.77793 4.91709C4.77793 7.0946 6.54315 8.85981 8.72065 8.85981C10.8982 8.85981 12.6634 7.0946 12.6634 4.91709C12.6634 2.73958 10.8982 0.974365 8.72065 0.974365ZM6.3813 17.363L8.39209 19.3737H0.835205V15.431C0.835205 13.2494 2.59629 11.4883 4.77793 11.4883H12.2691L6.3813 17.363ZM13.4309 20.688L10.1046 17.3603L11.9629 15.502L13.4309 16.9713L17.3066 13.0956L19.1649 14.954L13.4309 20.688Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCheckShareholder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/check-shareholder.1613da7b.svg";
export { ForwardRef as ReactComponent };